import { getConditionalObject } from 'utils/data';

import { getPendingChangeOutlinedHighlightStyles } from '../../../common/form/shared/styles';

const afterDefaultCustomStyles = {
  left: '-7px',
  top: '26px',
};

export const getFormControlLabelStyles = ({ customStyles, isFieldChanged, columns }) => {
  const { '&:after': afterCustomStyles, ...otherCustomStyles } = customStyles || {};

  return {
    margin: 0,
    justifyContent: 'flex-end',
    gap: '24px',
    minHeight: '38px',
    gridColumn: `span ${columns}`,
    height: '64px',
    paddingTop: '24px',

    ...getConditionalObject(isFieldChanged, () =>
      getPendingChangeOutlinedHighlightStyles(columns, {
        ...afterDefaultCustomStyles,
        ...afterCustomStyles,
      }),
    ),

    ...otherCustomStyles,
  };
};
